var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tinymce-container",class:{fullscreen:_vm.fullscreen},style:({width:_vm.containerWidth})},[_vm._ssrNode("<textarea"+(_vm._ssrAttr("id",_vm.tinymceId))+" class=\"tinymce-textarea\" data-v-a9d38a5e></textarea>")])
}
var staticRenderFns = []

export { render, staticRenderFns }